import { useState, useEffect, useRef } from 'react'
// router
import { useParams } from 'react-router'
// redux
import { useSelector } from 'react-redux'
// formik
import { useFormik } from 'formik'
// components
import {
    PageTitle,
    UploadImagePreview,
    RingsLoader,
    MainButton,
    ErrorMessage,
} from '../../../components'
// mui
import {
    Stack,
    Avatar,
    Box,
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@mui/material'
// axios
import enhancedAxios from '../../../utils/axiosUtils/enhancedAxios'
// schemas
import { editBannerSchema } from '../../../schemes/banners/editBannerSchema'
// alerts
import { errorAlert, successAlert } from '../../../utils/alerts'
// icons
import { FiUploadCloud } from 'react-icons/fi'
// utils
import { imageCompressor } from '../../../utils/comporessImage/imageCompressor'
const EditBanner = () => {
    const [file, setFile] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const inputFileRef = useRef()
    const userToken = useSelector((state) => state.userToken)
    const { id } = useParams()
    // ------------------------------   handle file changed toget value and for preview --------------------------
    const handleFileChange = async (e) => {
        let x = e.target.files[0]
        const final = await imageCompressor(x)
        setFile(final)
        setValues((prevValues) => ({ ...prevValues, img: final }))
    }
    // on Submit
    const onSubmit = (values) => {
        const formData = new FormData()
        for (let i in values) {
            formData.append(i, values[i])
        }
        enhancedAxios('multipart/form-data', userToken)
            .put(`/admin/banners/${id}`, formData)
            .then((response) => {
                successAlert('تم تعديل الاعلان')
                setSubmitting(false)
            })
            .catch((error) => {
                errorAlert(error)
                setSubmitting(false)
            })
    }
    // ------------------------------------ Form Validation Configraiton ----------------------------------------
    const {
        values,
        setValues,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isSubmitting,
        setSubmitting,
    } = useFormik({
        initialValues: {
            img: null,
            url: '',
            is_disabled: false,
        },
        validationSchema: editBannerSchema,
        onSubmit, //function we write above
        handleFileChange,
    })
    // ------------------------------------------- get current category data -------------------------
    useEffect(() => {
        enhancedAxios(null, userToken)
            .get(`/admin/banners/${id}`)
            .then((response) => {
                setValues({
                    ...values,
                    img: response.data.img,
                    url: response.data.url,
                    is_disabled: response.data.is_disabled,
                })
                setIsLoading(false)
            })
            .catch((error) => {
                errorAlert(error)
            })
    }, [id])
    // if data still loading render loaders
    if (isLoading) {
        return <RingsLoader />
    }
    return (
        <Stack width="100%" height="100%" spacing={8} alignItems="center">
            <PageTitle title="تعديل  الاعلان" />
            {/* ---------------------------------- form --------------------------------  */}
            <Stack
                component="form"
                spacing={2}
                onSubmit={handleSubmit}
                width="100%"
                maxWidth="600px"
            >
                {/* preview and upload image  */}
                <Stack spacing={1} flex="1">
                    {/* img preview section  */}
                    {typeof values.img != 'string' && (
                        <UploadImagePreview
                            file={file}
                            IPWidth="100%"
                            IPHeight="200px"
                            IPVariant="rounded"
                            IPObjectFit="cover"
                        />
                    )}
                    {typeof values.img == 'string' && (
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            gap="10px"
                        >
                            <Avatar
                                src={values.img}
                                alt="uploaded Image"
                                variant="rounded"
                                sx={{
                                    width: '100%',
                                    height: '200px',
                                    '& .MuiAvatar-img': {
                                        objectFit: 'cover',
                                    },
                                }}
                            />
                        </Box>
                    )}
                    <input
                        type="file"
                        onChange={handleFileChange}
                        name="img"
                        ref={inputFileRef}
                        hidden
                        accept="image/png, image/gif, image/jpeg"
                    ></input>
                    <Box display="flex" justifyContent="center" width="100%">
                        <Button
                            variant="contained"
                            color="success"
                            endIcon={<FiUploadCloud />}
                            onClick={() => inputFileRef.current.click()}
                        >
                            تحميل صورة
                        </Button>
                    </Box>
                </Stack>
                {/* link  */}
                <TextField
                    type="url"
                    name="url"
                    value={values.url}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="رابط الاعلان"
                />
                {/* is disabled  */}
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={values.is_disabled}
                            onChange={handleChange}
                            name="is_disabled"
                        />
                    }
                    label="اخفاء"
                />
                {/* submit form  */}
                <MainButton text="تعديل الاعلان" disabled={isSubmitting} />
                {/* errors section  */}
                {errors && (
                    <Stack spacing={1}>
                        {errors.url && touched.url && (
                            <ErrorMessage errorMsg={errors.url} />
                        )}
                        {errors.img && touched.img && (
                            <ErrorMessage errorMsg={errors.img} />
                        )}
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}

export default EditBanner
